import pxRunner from "../../pixels/runner";
import pixelDb from "../../pixels/ofertaNomina/pixelDb";
import state from "../../store/state";
describe("pxRunner config", () => {
  it("Debe ejecutar el pixel con el con el pfx y context", () => {
    let pfx = "PML.enviar";
    const context = { state: state };
    pxRunner.run(pfx, context, pixelDb);

    pfx = "PML.CATCH";
    pxRunner.run(pfx, context, pixelDb);
  });

  it("Ejecuto run del provider con enabled: false", () => {
    let pfx = "PML.enviar";
    const pixelDb = {
      providers: {
        PML: {
          enabled: false,
          queue: []
        }
      }
    };
    const context = { state: state };
    pxRunner.run(pfx, context, pixelDb);
  });

  it("Ingreso al catch", () => {
    let pfx = "PML.enviar";
    const pixelDb = {
      providers: {
        undefined: {}
      }
    };
    const context = { state: state };

    pxRunner.run(pfx, context, pixelDb);
  });

  it("Debe deshabilitar el provider ", () => {
    const provider = {
      enabled: false,
      loading: false,
      init: () => true,
      wait: () => true
    };
    const callback = jest.fn();
    pxRunner.enableProvider(provider, callback);
  });

  it("Habilitar provider", () => {
    const provider = {
      enabled: false,
      loading: false,
      init: () => true,
      wait: () => false
    };
    const callback = jest.fn();
    pxRunner.enableProvider(provider, callback);
  });

  it("configuracion exportada por defecto", () => {
    expect(pxRunner).toBeDefined();
    expect(pxRunner).not.toBeNull();
    expect(typeof pxRunner).toBe("object");
  });
});
